var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
export var getUserFollowDataGql = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query($id: String) {\n    userFollowData(id: $id) @rest(type: \"userFollowData\", path: \"/getUserFollowingData\", endpoint: \"query\") {\n      tracks\n      channels\n      videos\n      alertsEnabledChannels\n    }\n  }\n"], ["\n  query($id: String) {\n    userFollowData(id: $id) @rest(type: \"userFollowData\", path: \"/getUserFollowingData\", endpoint: \"query\") {\n      tracks\n      channels\n      videos\n      alertsEnabledChannels\n    }\n  }\n"])));
export var getUserFollowData = function () {
    return graphql(getUserFollowDataGql, {
        options: {
            variables: {},
        },
        props: function (_a) {
            var data = _a.data;
            return ({
                getUserFollowDataQuery: data,
            });
        },
    });
};
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/gql/queries/getUserFollowData.ts
// module id = 771
// module chunks = 81